module.exports = __webpack_public_path__ + "static/media/icon-info.4ac3f630.svg";